import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import * as React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";

function ResponsiveAppBar() {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null
  );

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <AppBar
      position="sticky"
      sx={{
        backgroundColor: "#0F172A",
        top: 0,
        zIndex: 1100,
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ minHeight: { xs: 56, md: 64 } }}>
          {/* Logo */}
          <NavLink to="/" style={{ textDecoration: "none" }}>
            <Typography
              variant="h6"
              noWrap
              sx={{
                fontWeight: 700,
                letterSpacing: "0.05em",
                color: "#FFFFFF",
                fontSize: { xs: "1rem", md: "1.1rem" },
              }}
            >
              Matsuki Takeshi
            </Typography>
          </NavLink>

          {/* Desktop nav links */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              gap: 1,
              ml: "auto",
              mr: 3,
              alignItems: "center",
            }}
          >
            <NavLink to="/" style={{ textDecoration: "none" }}>
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.7)",
                  fontWeight: 500,
                  fontSize: "0.9rem",
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 1,
                  "&:hover": { color: "#FFFFFF", backgroundColor: "rgba(255,255,255,0.08)" },
                  transition: "all 0.15s ease",
                }}
              >
                Home
              </Typography>
            </NavLink>
            <NavLink to="/biography" style={{ textDecoration: "none" }}>
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.7)",
                  fontWeight: 500,
                  fontSize: "0.9rem",
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 1,
                  "&:hover": { color: "#FFFFFF", backgroundColor: "rgba(255,255,255,0.08)" },
                  transition: "all 0.15s ease",
                }}
              >
                Biography
              </Typography>
            </NavLink>
          </Box>

          {/* Language switcher */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              gap: 0.5,
              mr: 1,
              alignItems: "center",
            }}
          >
            <Button
              size="small"
              onClick={() => changeLanguage("ja")}
              sx={{
                color: i18n.language === "ja" ? "#FFFFFF" : "rgba(255,255,255,0.5)",
                fontWeight: i18n.language === "ja" ? 600 : 400,
                fontSize: "0.75rem",
                minWidth: 36,
                px: 1,
                border: i18n.language === "ja" ? "1px solid rgba(255,255,255,0.3)" : "1px solid transparent",
                borderRadius: 1,
                "&:hover": { backgroundColor: "rgba(255,255,255,0.08)" },
              }}
            >
              JP
            </Button>
            <Button
              size="small"
              onClick={() => changeLanguage("en")}
              sx={{
                color: i18n.language === "en" ? "#FFFFFF" : "rgba(255,255,255,0.5)",
                fontWeight: i18n.language === "en" ? 600 : 400,
                fontSize: "0.75rem",
                minWidth: 36,
                px: 1,
                border: i18n.language === "en" ? "1px solid rgba(255,255,255,0.3)" : "1px solid transparent",
                borderRadius: 1,
                "&:hover": { backgroundColor: "rgba(255,255,255,0.08)" },
              }}
            >
              EN
            </Button>
          </Box>

          {/* Mobile hamburger */}
          <Box sx={{ display: { xs: "flex", md: "none" }, ml: "auto" }}>
            <IconButton
              onClick={handleOpenNavMenu}
              sx={{ color: "rgba(255,255,255,0.85)", p: 1 }}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={anchorElNav}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              keepMounted
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              PaperProps={{
                sx: {
                  mt: 1,
                  minWidth: 160,
                  borderRadius: 2,
                  boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
                  border: "1px solid #E2E8F0",
                },
              }}
            >
              <MenuItem onClick={handleCloseNavMenu} sx={{ px: 2 }}>
                <NavLink to="/" style={{ textDecoration: "none", width: "100%" }}>
                  <Typography fontWeight={500} color="text.primary">Home</Typography>
                </NavLink>
              </MenuItem>
              <MenuItem onClick={handleCloseNavMenu} sx={{ px: 2 }}>
                <NavLink to="/biography" style={{ textDecoration: "none", width: "100%" }}>
                  <Typography fontWeight={500} color="text.primary">Biography</Typography>
                </NavLink>
              </MenuItem>
              <Divider sx={{ my: 0.5 }} />
              <MenuItem
                sx={{ px: 2, gap: 1 }}
                onClick={() => { changeLanguage("ja"); handleCloseNavMenu(); }}
              >
                <Typography fontSize="0.85rem" color="text.secondary">日本語</Typography>
              </MenuItem>
              <MenuItem
                sx={{ px: 2, gap: 1 }}
                onClick={() => { changeLanguage("en"); handleCloseNavMenu(); }}
              >
                <Typography fontSize="0.85rem" color="text.secondary">English</Typography>
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;
